import axios from 'axios';

import activeServer from './apiBase';
import Drawings from './drawingsApi';

export const API = {
    Drawings,

    Users: {
        FetchSeats: async () => {
            const response = await axios.get(activeServer + '/users/seats', { withCredentials: true });
            return response.data;
        },

        Create: async (data) => {
            try {
                const response = await axios.post(`${activeServer}/users/new`, data, {
                    withCredentials: true // <-- Key for cookie-based auth
                });
                return response;
            } catch (error) {
                return { status: error.response?.status || 500, data: error.response?.data || { message: 'Unable to reach the server.' } };
            }
        },

        Update: async (updates) => {
            try {
                const response = await axios.patch(`${activeServer}/users/multi-update`, { updates }, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return { status: 400, data: error.response?.data || { message: 'Update failed' } };
            }
        },

        UpdateOne: async (id, data) => {
            try {
                const response = await axios.patch(`${activeServer}/users/update/${id}`, data, {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                return response;
            } catch (error) {
                return {
                    status: error.response?.status || 500,
                    data: error.response?.data || "Request failed",
                };
            }
        },

        Delete: async (ids) => {
            try {
                const response = await axios.delete(`${activeServer}/users/delete`, {
                    data: { ids: ids },
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return { status: 400, data: error.response?.data || { message: 'Delete failed' } };
            }
        },

        FetchAll: async () => {
            try {
                const response = await axios.get(`${activeServer}/users`, {
                    withCredentials: true // Send cookie automatically
                });
                return response.status === 200 ? response.data : [];
            } catch (error) {
                return [];
            }
        },

        FetchById: async (id) => {
            try {
                // Incomplete API Route
            } catch (error) {

            }
        }

    },

    Customers: {

        Create: async (id, data) => {
            try {
                const response = await axios.post(`${activeServer}/customers/new/${id}`, data, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return error?.response;
            }
        },

        Update: async (updates) => {
            try {
                const response = await axios.patch(`${activeServer}/customers/multi-update`, { updates }, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    status: 400,
                    data: error.response?.data || { message: "Update failed" }
                };
            }
        },

        UpdateOne: async (cid, data) => {
            try {
                const response = await axios.patch(`${activeServer}/customers/updateone/${cid}`, data, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    status: 400,
                    data: error.response?.data || { message: "Update failed" }
                };
            }
        },

        Delete: async (ids) => {
            try {
                const response = await axios.delete(`${activeServer}/customers/delete`, {
                    data: { ids },
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    status: 400,
                    data: error.response?.data || { message: "Delete failed" }
                };
            }
        },

        FetchAll: async () => {
            try {
                const response = await axios.get(`${activeServer}/customers`, {
                    withCredentials: true
                });
                return response.status === 200 ? response.data : [];
            } catch (error) {
                console.log(error);
                return [];
            }
        },

        FetchById: async (id) => {
            try {
                const response = await axios.get(`${activeServer}/customers/sn/${id}`, {
                    withCredentials: true
                });
                return response.status === 200 ? response.data : {};
            } catch (error) {
                console.log(error);
                return {};
            }
        },
    },

    Files: {
        UploadOpportunityFile: (id, data) => axios.post(`${activeServer}/files/upload/${id}`, data, { withCredentials: true }),
        DeleteOpportunityFile: (id, key) => axios.delete(`${activeServer}/files/delete`, { data: { opportunityId: id, key }, withCredentials: true }),

        GetSignedUrl: async (key) => {
            try {
                const response = await axios.get(`${activeServer}/files/signed-url`, {
                    params: { key },
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    status: error.response?.status || 400,
                    data: error.response?.data || { message: "Failed to open file" }
                };
            }
        },
    },

    Opportunities: {

        Create: async (data) => {
            try {
                const response = await axios.post(`${activeServer}/opportunities/new`, data, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    status: 400,
                    data: error.response?.data || { message: "Create failed" }
                };
            }
        },

        Update: async (updates) => {
            try {
                const response = await axios.patch(`${activeServer}/opportunities/multi-update`, { updates }, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    data: error.response?.data || { message: "Update failed" },
                    status: 400
                };
            }
        },

        UpdateDashboardForecasting: async (ids, data) => {
            try {
                const response = await axios.patch(`${activeServer}/opportunities/dashboard-forecasting-update`, { ids, data }, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    data: error.response?.data || { message: "Dashboard forecasting update failed" },
                    status: error.response?.status || 400,
                };
            }
        },

        UpdateSingle: async (id, payload) => {
            try {
                const response = await axios.patch(`${activeServer}/opportunities/update/${id}`, payload, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                console.log(error);
                return {
                    data: error.response?.data || { message: "Update failed" },
                    status: 400
                };
            }
        },

        Delete: async (ids) => {
            try {
                const response = await axios.delete(`${activeServer}/opportunities/delete`, {
                    data: { ids },
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    data: error.response?.data || { message: "Delete failed" },
                    status: error.response?.status || 400
                };
            }
        },

        FetchAll: async () => {
            try {
                const response = await axios.get(`${activeServer}/opportunities`, {
                    withCredentials: true
                });
                return response.status === 200 ? response.data : [];
            } catch (error) {
                return [];
            }
        },

        FetchArchived: async () => {
            try {
                const response = await axios.get(`${activeServer}/opportunities/archived`, {
                    withCredentials: true
                });
                return response.status === 200 ? response.data : [];
            } catch (error) {
                return [];
            }
        },

        FetchById: async (id) => {
            try {
                const response = await axios.get(`${activeServer}/opportunities/sn/${id}`, {
                    withCredentials: true
                });
                return response.status === 200 ? response.data : [];
            } catch (error) {
                console.log(error);
                return [];
            }
        },

        FetchByCustomer: async (id) => {
            try {
                const response = await axios.get(`${activeServer}/opportunities/customer/${id}`, {
                    withCredentials: true
                });
                return response.status === 200 ? response.data : [];
            } catch (error) {
                console.log(error);
                return [];
            }
        },

        FetchByStatus: async () => {
            try {
                // Incomplete API Route
            } catch (error) {

            }
        },

        FetchByUser: async (id) => {
            try {
                const response = await axios.get(`${activeServer}/quotes/user/${id}`, {
                    withCredentials: true
                  });
                return response.status === 200 ? response.data : []
            } catch (error) {
                console.log(error)
                return []
            }
        }

    },

    Settings: {
        FetchApplicationPublic: async () => {
            try {
                const response = await axios.get(`${activeServer}/settings/application/public`);
                return response.status === 200 ? response.data : {};
            } catch (error) {
                return {};
            }
        },

        FetchApplication: async () => {
            try {
                const response = await axios.get(`${activeServer}/settings/application`, {
                    withCredentials: true
                });
                return response.status === 200 ? response.data : {};
            } catch (error) {
                return {};
            }
        },

        UpdateApplication: async (payload) => {
            try {
                const response = await axios.patch(`${activeServer}/settings/application`, payload, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    status: error.response?.status || 400,
                    data: error.response?.data || { message: "Application settings update failed" }
                };
            }
        },

        Update: async (id, payload) => {
            try {
                const response = await axios.patch(`${activeServer}/settings/update/${id}`, payload, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                console.log(error);
                return {
                    status: 400,
                    data: error.response?.data || { message: 'Settings update failed' }
                };
            }
        },

        FetchByUser: async (id) => {
            try {
                const response = await axios.get(`${activeServer}/settings/user/${id}`, {
                    withCredentials: true
                });
                return response.status === 200 ? response.data : {};
            } catch (error) {
                return {};
            }
        },

    },

    Lines: {
        Create: async (oid, data) => {
            try {
                const response = await axios.post(`${activeServer}/lines/new/${oid}`, data, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    status: 400,
                    data: error.response?.data || { message: "Create failed" }
                };
            }
        },

        FetchByOpportunity: async (oid) => {
            try {
                const response = await axios.get(`${activeServer}/lines/opp/${oid}`, {
                    withCredentials: true
                });
                return response.status === 200 ? response.data : [];
            } catch (error) {
                console.log(error);
                return [];
            }
        },

        FetchById: async (id) => {
            try {
                const response = await axios.get(`${activeServer}/lines/sn/${id}`, {
                    withCredentials: true
                });
                return response.status === 200 ? response.data : {};
            } catch (error) {
                return {};
            }
        },

        UpdateMulti: async (oid, updates) => {
            try {
                const response = await axios.patch(`${activeServer}/lines/multi-update/${oid}`, { updates }, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    data: error.response?.data || { message: "Update failed" },
                    status: 400
                };
            }
        },

        UpdateSingle: async (id, oid, payload) => {
            try {
                const response = await axios.patch(`${activeServer}/lines/update/${id}?oid=${oid}`, payload, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                console.log(error);
                return {
                    data: error.response?.data || { message: "Update failed" },
                    status: 400
                };
            }
        },

        UpdateForecast: async (updates) => {
            try {
                const response = await axios.patch(`${activeServer}/lines/forecast-update`, { updates }, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    data: error.response?.data || { message: "Update failed" },
                    status: 400
                };
            }
        },

        Delete: async (oidOrIds, maybeIds) => {
            try {
                const hasOpportunityId = !Array.isArray(oidOrIds);
                const ids = hasOpportunityId ? maybeIds : oidOrIds;
                const response = await axios.delete(`${activeServer}/lines/delete`, {
                    data: { ids, ...(hasOpportunityId ? { oid: oidOrIds } : {}) },
                    withCredentials: true
                });
                return response;
            } catch (error) {
                console.log(error);
                return {
                    data: error.response?.data || { message: "Delete failed" },
                    status: 400
                };
            }
        },
    },

    Contacts: {

        FetchHistory: async (id) => {
            const response = await axios.get(`${activeServer}/contact/${id}/history`, { withCredentials: true });
            return response.data;
        },
        LogActivity: async (id, data) => {
            const response = await axios.post(`${activeServer}/contact/${id}/history`, data, { withCredentials: true });
            return response.data;
        },
        CompleteFollowUp: async (id, activityId, completed) => {
            const response = await axios.patch(`${activeServer}/contact/${id}/history/${activityId}/follow-up`, { completed }, { withCredentials: true });
            return response.data;
        },

        FetchOpportunities: async (id) => {
            const response = await axios.get(`${activeServer}/contact/${id}/opportunities`, {
                withCredentials: true
            });
            const opportunities = response.data;
            // Older contact endpoints omit quoteId. Resolve it from the same
            // response used by the main opportunities table during rollout.
            if (opportunities.some(opportunity => opportunity.quoteNumber && opportunity.quoteId === undefined)) {
                const mainResponse = await axios.get(`${activeServer}/opportunities`, {
                    withCredentials: true
                });
                const quotesByOpportunity = new Map(mainResponse.data.map(opportunity => [String(opportunity._id), opportunity.quoteId]));
                return opportunities.map(opportunity => ({
                    ...opportunity,
                    quoteId: opportunity.quoteId === undefined
                        ? quotesByOpportunity.get(String(opportunity._id)) || null
                        : opportunity.quoteId,
                }));
            }
            return opportunities;
        },

        UpdateSingle: async (id, data) => {
            const response = await axios.patch(`${activeServer}/contact/${id}`, data, {
                withCredentials: true
            });
            return response.data;
        },

        FetchSingle: async (id) => {
            const response = await axios.get(`${activeServer}/contact/${id}`, {
                withCredentials: true
            });
            return response.data;
        },

        Create: async (cid, data) => {
            try {
                const response = await axios.post(`${activeServer}/contact/new/${cid}`, data, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    status: 400,
                    data: error.response?.data || { message: "Create failed" }
                };
            }
        },

        Delete: async (cid, ids) => {
            try {
                const response = await axios.delete(`${activeServer}/contact/delete/${cid}`, {
                    data: { ids },
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    status: 400,
                    data: error.response?.data || { message: "Delete failed" }
                };
            }
        },

        Update: async (updates) => {
            try {
                const response = await axios.patch(`${activeServer}/contact/multi-update`, { updates }, {
                    withCredentials: true
                });
                return response
            } catch (error) {
                return { status: 400, data: error.response.data}
            }
        },

    },

    Reporting: {

        ForecastGraphWeighted: async (req,res) => {
            try {
                const response = await axios.get(`${activeServer}/reporting/forecast-graph-weighted`, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    status: 401,
                    data: error?.response?.data || { message: "Unauthorized" }
                };
            }
        },

        RevenueLinesFlat: async (req,res) => {
            try {
                const response = await axios.get(`${activeServer}/reporting/revenue-lines-flat`, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    status: 401,
                    data: error?.response?.data || { message: "Unauthorized" }
                };
            }
        },

        RSMReminder: async () => {
            try {
                const response = await axios.get(`${activeServer}/reporting/rsm-reminder`, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    status: 401,
                    data: error?.response?.data || { message: "Unauthorized" }
                };
            }
        },

        DashboardForecasting: async () => {
            try {
                const response = await axios.get(`${activeServer}/reporting/dashboard-forecasting`, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    status: 401,
                    data: [],
                    message: error.response?.data?.message || "Unauthorized or server error",
                };
            }
        },

        DashboardActiveProjects: async () => {
            try {
                const response = await axios.get(`${activeServer}/reporting/dashboard-active-projects`, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    status: 401,
                    data: [],
                    message: error.response?.data?.message || "Unauthorized or server error",
                };
            }
        },

        ShippingCalendar: async (req,res) => {
            try {
                const response = await axios.get(`${activeServer}/reporting/shipping-calendar`, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    status: 401,
                    data: error?.response?.data || { message: "Unauthorized" }
                };
            }
        },
    },

    OpportunityLogs: {
        FetchByOppId: async (id) => {
            try {
                const response = await axios.get(`${activeServer}/opportunity-logs/${id}`, {
                    withCredentials: true
                });
                return response.status === 200 ? response.data : [];
            } catch (error) {
                console.log(error);
                return [];
            }
        },
    },

    Dashboard: {
        SendOppsToDash: async (id, data) => {
            try {
                const response = await axios.patch(`${activeServer}/dashboard-settings/add-opps/${id}`, { data }, {
                    withCredentials: true
                })
                return response
            } catch (error) {
                return { status: 400, data: error.response.data}
            }
        },

        FetchByUser: async (uid) => {
            try {
                const response = await axios.get(`${activeServer}/dashboard-settings/${uid}`, {
                    withCredentials: true
                })
                return response.data[0]
            } catch (error) {
                return { status: 400, data: error.response.data}
            }
        },

        RemoveOpp: async (uid, id) => {
            try {
                const response = await axios.delete(`${activeServer}/dashboard-settings/remove-opp/${uid}`, {
                    data: { id },
                    withCredentials: true
                })
                return response
            } catch (error) {
                return { status: 400 , data: "Failed To Remove Opportunity..."}
            }
        },

        SendCustomersToDash: async (id, data) => {
            try {
                const response = await axios.patch(`${activeServer}/dashboard-settings/add-customers/${id}`, { data }, {
                    withCredentials: true
                })
                return response
            } catch (error) {
                return { status: 400, data: error.response.data}
            }
        },

        RemoveCustomer: async (uid, id) => {
            try {
                const response = await axios.delete(`${activeServer}/dashboard-settings/remove-customer/${uid}`, {
                    data: { id },
                    withCredentials: true
                })
                return response
            } catch (error) {
                return { status: 400 , data: "Failed To Remove Customer..."}
            }
        },

        AddModule: async (uid, module) => {
            try {
                const response = await axios.patch(`${activeServer}/dashboard-settings/add-module/${uid}`, { module }, {
                    withCredentials: true
                })
                return response
            } catch (error) {
                return { status: 400, data: "Failed to update dashboard" }
            }
        },

        RemoveModule: async (uid, module) => {
            try {
                const response = await axios.patch(`${activeServer}/dashboard-settings/remove-module/${uid}`, { module }, {
                    withCredentials: true
                })
                return response
            } catch (error) {
                return { status: 400, data: "Failed to update dashboard" }
            }
        }
    },

    Authentication: {

        Login: async (formData) => {
            try {
                const response = await axios.post(`${activeServer}/auth/login`,formData,
                    { withCredentials: true } // include cookie!
                );
                return response
            } catch (error) {
                return error
            }
        },

        ValidateUser: async () => {
            try {
                const response = await axios.get(`${activeServer}/auth/check`, {
                    withCredentials: true
                });
                return response
            } catch (error) {
                return error
            }
        },

        Logout: async () => {
            try {
                const response = await axios.post(`${activeServer}/auth/logout`, {}, {
                    withCredentials: true
                });
                return response
            } catch (error) {
                return error
            }
        }
    },

    Notifications: {
        FetchByUser: async (id) => {
            try {
                const response = await axios.get(`${activeServer}/notifications/usr/${id}`, {
                    withCredentials: true // Send cookie automatically
                });
                return response.status === 200 ? response.data : [];
            } catch (error) {
                return []
            }
        },

        Delete: async (id) => {
            try {
                const response = await axios.delete(`${activeServer}/notifications/delete/${id}`, {
                    withCredentials: true // Send cookie automatically
                })
                return response
            } catch (error) {
                return { status: 400 }
            }
        }
    },

    Forecasting: {

        Create: async (data) => {
            try {
                const response = await axios.post(`${activeServer}/forecasting/new`, data, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return error?.response;
            }
        },

        FetchAll: async () => {
            try {
                const response = await axios.get(`${activeServer}/forecasting`, {
                    withCredentials: true // Send cookie automatically
                });
                return response.status === 200 ? response.data : [];
            } catch (error) {
                return []
            }
        },

        Delete: async (ids) => {
            try {
                const response = await axios.delete(`${activeServer}/forecasting/delete`, {
                    data: { ids },
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    status: 400,
                    data: error.response?.data || { message: "Delete failed" }
                };
            }
        },

        GenerateComparisonPdf: async (report) => {
            try {
                const response = await axios.post(`${activeServer}/forecasting/comparison-report/pdf`, { report }, {
                    withCredentials: true,
                    responseType: "arraybuffer",
                });
                return response;
            } catch (error) {
                return {
                    status: error?.response?.status || 400,
                    data: error?.response?.data || { message: "Failed to generate comparison PDF" }
                };
            }
        },

    },

    Catalogs: {

        FetchAll: async () => {
            try {
                const response = await axios.get(`${activeServer}/catalog`, {
                    withCredentials: true // Send cookie automatically
                });
                return response.status === 200 ? response.data : [];
            } catch (error) {
                return []
            }
        },

        FetchAllPopulated: async () => {
            try {
                const response = await axios.get(`${activeServer}/catalog/populated`, {
                    withCredentials: true // Send cookie automatically
                });
                return response.status === 200 ? response.data : [];
            } catch (error) {
                return []
            }
        },

        FetchOne: async (cid) => {
            try {
                const response = await axios.get(`${activeServer}/catalog/single/${cid}`, {
                    withCredentials: true // Send cookie automatically
                });
                return response.status === 200 ? response.data : [];
            } catch (error) {
                return []
            }
        },

        Create: async (data) => {
            try {
                const response = await axios.post(`${activeServer}/catalog/new`, data, {
                    withCredentials: true // <-- Key for cookie-based auth
                });
                return response;
            } catch (error) {
                return { status: 400, data: error.response.data };
            }
        },

        Delete: async (ids) => {
            try {
                const response = await axios.delete(`${activeServer}/catalog/delete`, {
                    data: { ids },
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    status: 400,
                    data: error.response?.data || { message: "Delete failed" }
                };
            }
        },

        UpdateMulti: async (updates) => {
            try {
                const response = await axios.patch(`${activeServer}/catalog/multi-update`, { updates }, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    data: error.response?.data || { message: "Update failed" },
                    status: 400
                };
            }
        },
    },

    Products: {

        FetchOne: async (pid) => {
            try {
                const response = await axios.get(`${activeServer}/products/single/${pid}`, {
                    withCredentials: true // Send cookie automatically
                });
                return response.status === 200 ? response.data : [];
            } catch (error) {
                return {}
            }
        },

        FetchLogs: async (pid) => {
            try {
                const response = await axios.get(`${activeServer}/products/logs/${pid}`, {
                    withCredentials: true // Send cookie automatically
                });
                return response.status === 200 ? response.data : [];
            } catch (error) {
                return {}
            }
        },

        Create: async (cid,data) => {
            try {
                const response = await axios.post(`${activeServer}/products/new/${cid}`, data, {
                    withCredentials: true // <-- Key for cookie-based auth
                });
                return response;
            } catch (error) {
                return { status: 400, data: error.response.data };
            }
        },

        UpdateMulti: async (updates) => {
            try {
                const response = await axios.patch(`${activeServer}/products/multi-update`, { updates }, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    data: error.response?.data || { message: "Update failed" },
                    status: 400
                };
            }
        },

        Delete: async (ids) => {
            try {
                const response = await axios.delete(`${activeServer}/products/delete`, {
                    data: { ids },
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    status: 400,
                    data: error.response?.data || { message: "Delete failed" }
                };
            }
        },

        ExportToExcel: async (cid) => {
            try {
                const response = await axios.patch(`${activeServer}/products/export-to-excel/${cid}`, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    status: 400,
                    data: error.response.data
                }
            }
        },

        PriceIncrease: async (ids, priceValue) => {
            try {
                const response = await axios.patch(`${activeServer}/products/price-increase`, { ids, priceValue }, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    data: error.response?.data || { message: "Update failed" },
                    status: 400
                };
            }
        },

        Search: async (q, limit = 25) => {
            try {
                const response = await axios.get(`${activeServer}/products/search`, {
                    params: { q, limit },
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return { status: 400, data: error.response?.data };
            }
        },
    },

    Quotes: {

        Create: async (data) => {
            try {
                const response = await axios.post(`${activeServer}/quotes/new`, data, {
                    withCredentials: true // <-- Key for cookie-based auth
                });
                return response;
            } catch (error) {
                return { status: 400, data: error.response.data };
            }
        },

        CreateRevision: async (id, data) => {
            try {
                const response = await axios.post(`${activeServer}/quotes/revision/${id}`, data, {
                    withCredentials: true // <-- Key for cookie-based auth
                });
                return response;
            } catch (error) {
                return { status: 400, data: error.response.data };
            }
        },

        FetchAll: async () => {
            try {
                const response = await axios.get(`${activeServer}/quotes`, {
                    withCredentials: true // Send cookie automatically
                });
                return response.status === 200 ? response.data : [];
            } catch (error) {
                return []
            }
        },

        Delete: async (ids) => {
            try {
                const response = await axios.delete(`${activeServer}/quotes/delete`, {
                    data: { ids },
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    status: 400,
                    data: error.response?.data || { message: "Delete failed" }
                };
            }
        },

        FetchOne: async (qid) => {
            try {
                const response = await axios.get(`${activeServer}/quotes/single/${qid}`, {
                    withCredentials: true // Send cookie automatically
                });
                return response.status === 200 ? response.data : [];
            } catch (error) {
                return []
            }
        },

        Update: async (qid, body, config) => {
        const res = await axios.patch(`${activeServer}/quotes/update/${qid}`, body, {
            withCredentials: true,
            ...(config || {}),
        });
        return res.data;
        },

        UpdateMulti: async (updates) => {
            try {
                const response = await axios.patch(`${activeServer}/quotes/multi-update`, { updates }, {
                    withCredentials: true
                });
                return response;
            } catch (error) {
                return {
                    data: error.response?.data || { message: "Update failed" },
                    status: 400
                };
            }
        },

        DeliveryPDF: async (qid) => {
            const response = await axios.get(`${activeServer}/quotes/deliver-pdf/${qid}`, {
                withCredentials: true,
                responseType: "arraybuffer",
            });
            return response;
        },

        PreviewPDF: (qid) => axios.get(`${activeServer}/quotes/preview-pdf/${qid}`, {
            withCredentials: true,
            responseType: "arraybuffer",
        }),

        DeliveryPDFNoPricing: async (qid) => {
            const response = await axios.get(`${activeServer}/quotes/deliver-pdf-no-pricing/${qid}`, {
                withCredentials: true,
                responseType: "arraybuffer",
            });
            return response;
        },

        DeliverPDFWithDrawing: async (qid, drawingPdfFile) => {
            // drawingPdfFile should be the File object from <input type="file" />
            const formData = new FormData();
            formData.append("drawingPdf", drawingPdfFile); // MUST match upload.single("drawingPdf")

            const response = await axios.post(
                `${activeServer}/quotes/pdf/${qid}/deliver-with-drawing`,
                formData,
                {
                withCredentials: true,
                responseType: "arraybuffer",
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                }
            );

            return response;
        },

        DeliveryOrderConfirmation: async (qid) => {
            const response = await axios.get(`${activeServer}/quotes/deliver-confirmation/${qid}`, {
                withCredentials: true,
                responseType: "arraybuffer",
            });
            return response;
        },

        DeliveryWeeklyReport: async (start,end) => {
            const response = await axios.get(`${activeServer}/quotes/deliver-weekly-report?startDate=${start.toISOString()}&endDate=${end.toISOString()}`, {
                withCredentials: true,
                responseType: "arraybuffer",
            });
            return response;
        },

        Copy: async (qid, data) => {
            try {
                const response = await axios.post(`${activeServer}/quotes/copy/${qid}`, data, {
                    withCredentials: true // <-- Key for cookie-based auth
                });
                return response;
            } catch (error) {
                return { status: 400, data: error.response.data };
            }
        },

        RefreshPricing: async (id) => {
            try {
                const response = await axios.post(
                    `${activeServer}/quotes/refresh-pricing/${id}`,
                    {}, // no body needed
                    {
                        withCredentials: true
                    }
                );
                return response;
            } catch (error) {
                return {
                    status: error?.response?.status || 400,
                    data: error?.response?.data || { message: "Failed to refresh pricing." }
                };
            }
        },

        Search: async ({ part, tags = [], tagsMode = "all", page = 0, limit = 15, sortField, sortDirection, filterModel } = {}) => {
            try {
                const response = await axios.get(`${activeServer}/quotes/search`, {
                params: {
                    part: part?.trim() || undefined,
                    tags: tags.length ? tags.join(",") : undefined,
                    tagsMode, // âœ… pass through
                    page,
                    limit,
                    sortField,
                    sortDirection,
                    filterModel: filterModel ? JSON.stringify(filterModel) : undefined,
                },
                withCredentials: true,
                });
                return response;
            } catch (error) {
                return { status: error?.response?.status || 400, data: error?.response?.data };
            }
        },

        FetchPaged: async (params = {}) => API.Quotes.Search(params),

    },

    Chats: {
        FetchAll: async () => {
            try {
                const response = await axios.get(`${activeServer}/chat`, {
                    withCredentials: true // Send cookie automatically
                });
                return response.status === 200 ? response.data : [];
            } catch (error) {
                return []
            }
        },

        FetchMessages: async (chatId, params = {}) => {
            try {
                const response = await axios.get(
                `${activeServer}/chat/${chatId}/messages`,
                {
                    params,              // { limit, before }
                    withCredentials: true
                }
                );
                return response;
            } catch (error) {
                console.error("FetchMessages failed", error);
                throw error;
            }
        },

        SendMessage: async (chatId, payload) => {
            const response = await axios.post(
                `${activeServer}/chat/${chatId}/messages`,
                payload,
                { withCredentials: true }
            );
            return response;
        },

        GetChatUploadUrl: async (chatId, payload) => {
            return axios.post(
                `${activeServer}/chat/${chatId}/upload-url`,
                payload,
                { withCredentials: true }
            );
        },

        GetChatDownloadUrl: (key) =>
            axios.get(`${activeServer}/chat/files/presigned-get`, {
            params: { key },
            withCredentials: true,
        }),

        MarkRead: async (chatId) => {
            return axios.patch(
            `${activeServer}/chat/${chatId}/read`,
            {},
            { withCredentials: true }
            );
        },
    },

}
